export default __webpack_public_path__ + "static/media/desfa-logo.9b1796fe.png";